require('./bootstrap');
axios.get('/trans').then(function (response) {
    window.trans = response.data;
    require('./vues');
})
